import { Action } from '@ngrx/store';
import { AuthActionType } from 'app/core/authentication/state/actions/auth-action-type.enum';
import { Error } from 'app/core/error-handler/models';

import { Credentials } from 'app/core/authentication/models';

export class Login implements Action {
  public readonly type: AuthActionType = AuthActionType.Login;
  public readonly payload: Credentials;

  constructor(username: string, password: string) {
    this.payload = {
      username,
      password,
    };
  }
}

export class LoginCompleted implements Action {
  public readonly type: AuthActionType = AuthActionType.LoginCompleted;

  constructor(public readonly payload: string) { }
}

export class LoginFailed implements Action {
  public readonly type: AuthActionType = AuthActionType.LoginFailed;

  constructor(public readonly payload: Error) { }
}
